import React, { useEffect, useState, useRef } from 'react';

interface CountdownProps {
  onComplete: () => void;
  isGameInitialized: boolean;
  currentLevel: number;
}

const Countdown: React.FC<CountdownProps> = ({ onComplete, isGameInitialized, currentLevel }) => {
  const [countdown, setCountdown] = useState<number | null>(null);
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (!isGameInitialized) {
      hasStartedRef.current = false;
      setCountdown(null);
      return;
    }

    if (isGameInitialized && !hasStartedRef.current) {
      hasStartedRef.current = true;
      setCountdown(3);
    }
  }, [isGameInitialized]);

  useEffect(() => {
    if (countdown === null || countdown < 0) {
      return;
    }

    if (countdown === 0) {
      const goTimer = setTimeout(() => {
        setCountdown(-1);
        onComplete();
      }, 800);
      return () => clearTimeout(goTimer);
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => (prev !== null ? prev - 1 : null));
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, onComplete]);

  if (countdown === null || countdown < 0) {
    return null;
  }

  return (
    <div className="countdown-overlay">
      <div className="countdown-content">
        <div className="countdown-level-badge">LEVEL {currentLevel}</div>
        <div className="countdown-message">GET READY!</div>
        <div className={`countdown-number ${countdown === 0 ? 'countdown-go' : ''}`}>
          {countdown > 0 ? countdown : "GO!"}
        </div>
      </div>
    </div>
  );
};

export default Countdown;

